<template>
    <div class="calm-right-files-wrapper">
        <div v-if="selectedFiles?.length === 0" class="empty-state">
            <img src="../../../../public/icons/landscape/EmptyStateFilesList.svg" />
            <h3 class="fs18">
                {{ localizer.Localize("LandscapeManagement_SelectObjects") }}
            </h3>
            <p>{{ localizer.Localize("LandscapeManagement_ObjectsDisplay") }}</p>
        </div>
        <div class="selected-state" v-else>
            <div class="collapsible-header">
                <div class="flex items-center">
                    <f-icon icon="chevronright" class="clickable" :class="{ 'is-expanded': isExpanded }"
                        @click="toggleExpandeCollapse" />
                    <h4 class="mb0 ml5">
                        {{ localizer.Localize("LandscapeManagement_Files") }}
                    </h4>
                </div>
            </div>
            <div class="collapsible-content" :class="{ open: isExpanded }">
                <div v-for="Fso in selectedFiles" :key="Fso.id" class="calm-right-file-item">
                    <div class="flex items-center">
                        <FileSystemObjectIcon :Fso="Fso" />
                        <span class="name ml5" :title="Fso?.name ? Fso?.name : ''">{{ Fso?.name }}</span>
                    </div>
                    <div v-if="!isReadonly" class="flex items-center">
                        <f-tooltip>
                            <template #title>
                                <div class="tooltip-path-content">
                                    <span>{{ localizer.Localize("LandscapeManagement_Path") }}</span>
                                    <span>{{ getPath(Fso) }}</span>
                                </div>
                            </template>
                            <img src="../../../../public/icons/landscape/PathIcon.svg"
                                class="icon theme-svg clickable" />
                        </f-tooltip>
                        <f-icon icon="delete" class="theme-svg clickable ml5"
                            @click="$emit('removeItem', false, Fso)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";
import { IAlmFileSystemObjectContent } from "@/components/pages/landscape/LandscapeManagementInterfaces";
import FileSystemObjectIcon from "@/components/helpers/FileSystemObjectIcon.vue";

export default defineComponent({
    components: {
        FileSystemObjectIcon,
    },
    props: {
        selectedFiles: Array<IAlmFileSystemObjectContent>,
        isReadonly: Boolean,
        isFilesExpanded: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
            isExpanded: this.isFilesExpanded
        };
    },
    methods: {
        toggleExpandeCollapse() {
            this.isExpanded = !this.isExpanded;
        },
        getPath(fsoChild: IAlmFileSystemObjectContent): string {
            const arr: Array<string> | undefined = fsoChild?.fullPath?.split("/").filter((fileName: string) => {
                return !!fileName;
            });
            return arr?.join(" > ") || "";
        },
    },
});
</script>

<style scoped>
.calm-right-files-wrapper {
    display: flex;
    flex-direction: column;
    height: calc(100% - 64px);
}

.empty-state {
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    justify-content: center;
}

.empty-state h3 {
    margin-top: 20px;
    font-size: 14px;
}

.empty-state p {
    text-align: center;
    font-size: 13px;
    line-height: 13px;
}

.selected-state {
    height: 100%;
}

.collapsible-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.is-expanded {
    transform: rotate(90deg);
}

.ml5 {
    margin-left: 5px;
}

.mb0 {
    margin-bottom: 0;
}

.name {
    white-space: nowrap;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.clickable {
    cursor: pointer;
}

.collapsible-content {
    display: none;
    overflow: hidden;
}

.collapsible-content.open {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: calc(100% - 40px);
}

.calm-right-file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
}

.icon {
    width: 24px;
    height: 24px;
}

.tooltip-path-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
}
</style>

<style>
.ant-tooltip-inner:has(.tooltip-path-content) {
    min-width: 150px;
    border: 1px solid var(--accent-color);
    box-shadow: 0px 4px 5px 0px var(--sidebar-foreground-12);
    background: var(--background-even) !important;
    color: var(--foreground-primary);
    margin-right: 5px;
}
</style>
